import React from 'react';
import { Scene } from './components/Scene';
import './App.css';

function App() {
  return (
    <div className="App">
      <Scene />
    </div>
  );
}

export default App;
